import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { InvoiceType, PayModeLevel1 } from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'invoice-type',
  templateUrl: './invoice-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class InvoiceTypeComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  getMode(value: number, data: any) {
    if (!value || value == 0) return '-';
    else if (Object.keys(value).length == 0) {
      return '-';
    } else {
      return InvoiceType[value];
    }
  }
}
